import { render, staticRenderFns } from "./file-store-modal.vue?vue&type=template&id=66f4a5f2&scoped=true"
import script from "./file-store-modal.vue?vue&type=script&lang=js"
export * from "./file-store-modal.vue?vue&type=script&lang=js"
import style0 from "./file-store-modal.vue?vue&type=style&index=0&id=66f4a5f2&prod&lang=css"
import style1 from "./file-store-modal.vue?vue&type=style&index=1&id=66f4a5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f4a5f2",
  null
  
)

export default component.exports